<template>
	<!-- 机构标的 -->
	<div>
		<p style="line-height: 90px;border-bottom: 1px solid #dcdcdc;padding-left: 40px;" v-if="hasEnterprise == true && hasEnterpriseStatu == 0">审核未通过！原因：{{ enterprise.remark }}</p>
		<div class="organization" v-if="hasEnterprise == false || hasEnterpriseStatu == 0">
			<div class="autonym_title">填写机构信息</div>
			<div class="a_center">
				<span class="leftname">法人姓名:</span>
				<input type="text" placeholder="请输入您的真实姓名" name="name" class="input" v-model="enterpriseDatas.names">
			</div>
			<div class="a_center">
				<span class="leftname">法人身份证号:</span>
				<input type="text" placeholder="请输入您的身份证号" name="idcard" class="input" v-model="enterpriseDatas.cardId">
			</div>
			<div class="a_center">
				<span class="leftname">机构logo:</span>
				<div class="logo_box">
					<img class="tx" :src="updateImgEnterprise[4].url" v-if="updateImgEnterpriseShow[4].bool == true">
					<input type="file" @change="getFile($event,4,2)" name="ID_card" class="ID_card">
					<img class="tx" src="@/assets/images/h.png" v-if="updateImgEnterpriseShow[4].bool == false">
				</div>
				<span class="logo_send">点击图片上传logo</span>
			</div>
			<div class="a_center">
				<span class="leftname">机构名称:</span>
				<input type="text" placeholder="请输入机构名称" name="organization_name" class="input" v-model="enterpriseDatas.titles">
			</div>
			<div style="align-items: flex-start;">
				<span class="leftname">机构简介:</span>
				<textarea type="text" placeholder="请输入机构简介" name="organization_text" class="textarea" v-model="enterpriseDatas.summary"></textarea>
			</div>
			<div class="a_center">
				<span class="leftname">机构标语:</span>
				<input type="text" placeholder="请输入机构标语" name="organization_name" class="input" v-model="enterpriseDatas.slogan">
			</div>
			<div class="a_center">
				<span class="leftname">联系电话:</span>
				<input type="text" placeholder="请输入联系电话" name="organization_name" class="input" maxlength="11" v-model="enterpriseDatas.phone">
			</div>
			<div class="a_center">
				<span class="leftname">验证码:</span>
				<input type="text" placeholder="请输入验证码" name="organization_name" class="input" maxlength="6" v-model="enterpriseDatas.codes">
				<button class="send_code" @click="enterpriseSendCode" :disabled="disabled" :class="{ sendding : disabled }">{{ enterpriseCode }}</button>
			</div>
			<div class="autonym_title">上传机构照片</div>
			<div class="o_item" v-for="(item,index) in updataImgEnterpriseArr" :key="index">
				<span class="idcard_tit">{{ item.title }}</span>
				<div class="idcard_picture">
					<div class="idcard_sendz" :style="{'backgroundImage':'url(' + updateImgEnterprise[index].url + ')'}">
						<input type="file" @change="getFile($event,index,2)" name="ID_card" class="ID_card">
						<p v-if="updateImgEnterpriseShow[index].bool == true" class="reup">点击重新上传</p>
						<img src="@/assets/images/sendpic.png" v-if="updateImgEnterpriseShow[index].bool == false">
						<p v-if="updateImgEnterpriseShow[index].bool == false">{{ item.tipsText }}</p>
					</div>
					<div><img :src="item.rImg"></div>
				</div>
			</div>
			<p class="sub_tips">{{ subTips }}</p>
			<button class="zenbu" @click="checkSubmit">提交</button>
		</div>
		<!-- 机构中心 认证后进入 -->
		<div class="person_info organization" v-if="hasEnterprise == true">
			<div v-if="hasEnterpriseStatu == 2">您已提交审核，请耐心等待...</div>
			<ul v-if="hasEnterpriseStatu == 1">
				<li><span class="lefttitle">机构logo：</span><img :src="enterprise.img"></li>
				<li><span class="lefttitle">机构名称：</span><span>{{ enterprise.title }}</span></li>
				<li><span class="lefttitle">机构简介：</span><span>{{ enterprise.summary }}</span></li>
				<li><span class="lefttitle">法人姓名：</span><span>{{ enterprise.name }}</span></li>
				<li><span class="lefttitle">联系电话：</span><span>{{ enterprise.phone }}</span></li>  
			</ul>
		</div>
	</div>
</template>

<script>
import qs from 'qs'

export default {
	name: 'OrganizationCenter',
	inject: ['reload'],
	data (){
		return{
			token: localStorage.getItem('apiToken'),
			hasEnterprise: false, //判断有无机构
			hasEnterpriseStatu: '',
			enterprise: [], //机构中心数据
			updataImgEnterpriseArr: [
				{
					title: '*请上传法人身份证人像图',
					tipsText: '上传法人身份证人像图',
					rImg: require('@/assets/images/idcardz.png')
				},
				{
					title: '*请上传法人身份证国徽图',
					tipsText: '上传法人身份证国徽图',
					rImg: require('@/assets/images/idcardf.png')
				},
				// {
				// 	title: '*请上传法人手持身份证图',
				// 	tipsText: '上传法人手持身份证图',
				// 	rImg: require('@/assets/images/idcards.png')
				// },
				{
					title: '*请上传营业执照照片',
					tipsText: '上传营业执照照片',
					rImg: require('@/assets/images/idcardy.png')
				}
			],
			enterpriseDatas: [ //机构中心表单信息
				{names: ''},
				{cardId: ''},
				{titles: ''},
				{summary: ''},
				{slogan: ''},
				{phone: ''},
				{codes: ''}
			],
			enterpriseCode: '获取验证码',
			error: '',
			updateImgEnterpriseShow: [
				{bool: false},
				{bool: false},
				{bool: false},
				{bool: false},
				{bool: false}
			],
			updateImgEnterprise: [ //机构中心图片信息
				{url:''},
				{url:''},
				{url:''},
				{url:''},
				{url:''}
			],
			subTips: '',
			disabled: false,
			only_once: true
		}
	},
	created(){
		// 请求个人资料数据
		this.axios.get(this.$global.apiUrl.customer, {
			params: {
				apiToken: this.token
			}
		})
		.then((response) => {
			if(response.data.error.code == 0){
				this.customerDatas = response.data.customer
				this.hasEnterprise = response.data.hasEnterprise
				if( this.hasEnterprise == true ){
					this.axios.get(this.$global.apiUrl.enterprise, {
						params: {
							apiToken: this.token
						}
					})
					.then((response) => {
						if(response.data.error.code == 0){
							this.enterprise = response.data.enterprise
							this.hasEnterpriseStatu = response.data.enterprise.status
						}
					})
					.catch(() => {})
				}
			}
		})
		.catch(() => {})
	},
	watch:{
		
	},
	mounted(){

	},
	computed: {

	},
	methods: {
		// 上传图片
		getFile: function(event,index,n){
			if( n == 2 ){
				const file = event.target.files[0]
				//请求接口前需要传的参数
				let formData = new FormData()
				formData.append('apiToken', this.token)
				formData.append('file', file)
				this.axios.post(this.$global.apiUrl.upload_file, formData, {
					headers: {
						'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
					}
				})
				.then((response) => {
					if(response.data.error.code == 0){
						this.updateImgEnterprise[index].url = response.data.url
						this.updateImgEnterpriseShow[index].bool = true
					}
				})
				.catch(() => {})
			}else{
				const file = event.target.files[0]
				//请求接口前需要传的参数
				let formData = new FormData()
				formData.append('apiToken', this.token)
				formData.append('file', file)
				this.axios.post(this.$global.apiUrl.upload_file, formData, {
					headers: {
						'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
					}
				})
				.then((response) => {
					if(response.data.error.code == 0){
						this.updateImgEnterprise[4].url = response.data.url
						this.updateImgEnterpriseShow[4].bool = true
					}
				})
				.catch(() => {})
			}
		},
		// 发送验证码
		enterpriseSendCode () {
			const pattern = /0?(13|14|15|17|18|19)[0-9]{9}/;
			if( this.enterpriseDatas.phone == '' || !pattern.test(this.enterpriseDatas.phone) ){
				this.error = '手机号码格式不正确'
				this.$alert(this.error, '提示', {
					confirmButtonText: '确定'
				});
				this.only_once = true
			} else {
				if( this.only_once == true ){
					this.only_once = false;
					let phoneData = qs.stringify({'phone': this.enterpriseDatas.phone})
					this.axios.post(this.$global.apiUrl.send_code, phoneData, {
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded'
						}
					})
					.then((response) => {
						if (response.data.error.code == 0){
							let times = 0
							let i = setInterval(() => {
								times++
								if (times >= 60) {
									this.disabled = false,
									this.enterpriseCode = "重新获取"
									clearInterval(i)
								} else {
									let balance = 60 - times
									this.enterpriseCode = balance + "s",
									this.disabled = true
								}
							}, 1000)
							this.$alert(this.error, '提示', {
								confirmButtonText: '确定'
							});
						}else{
							this.error = response.data.error.message
							this.$alert(this.error, '提示', {
								confirmButtonText: '确定'
							});
							this.only_once = true
						}
					})
					.catch(() => {})
				}
			}
		},
		// 机构中心提交
		postEnterpriseName: function(){
			this.$confirm('您确定提交?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消'
			}).then(() => {
				let realDatas = qs.stringify({
					phone: this.enterpriseDatas.phone,
					code: this.enterpriseDatas.codes,
					title: this.enterpriseDatas.titles,
					slogan: this.enterpriseDatas.titles,
					summary: this.enterpriseDatas.summary,
					name: this.enterpriseDatas.names,
					cardId: this.enterpriseDatas.cardId,
					cardImgF:this.updateImgEnterprise[0],
					cardImgB: this.updateImgEnterprise[1],
					cardImgH: this.updateImgEnterprise[2],
					licenseImg: this.updateImgEnterprise[3],
					img: this.updateImgEnterprise[4],
					apiToken: this.token
				})
				if(realDatas){
					this.axios.post(this.$global.apiUrl.enterprise_store, realDatas, {
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded'
						}
					})
					.then((response) => {
						if (response.data.error.code == 0){
							this.$alert('提交成功，请耐心等待审核', '提示', {
								confirmButtonText: '确定'
							});
							// this.reload()
							this.hasEnterprise = true
							// 请求机构中心数据
							if( this.hasEnterprise == true ){
								this.axios.get(this.$global.apiUrl.enterprise, {
									params: {
										apiToken: this.token
									}
								})
								.then((response) => {
									if(response.data.error.code == 0){

										this.enterprise = response.data.enterprise
										this.hasEnterpriseStatu = response.data.enterprise.status
									}
								})
								.catch(() => {})
							}
						}else{
							alert(response.data.error.message);
						}
					})
					.catch(() => {})
				}
			}).catch(() => {});
		},
		// 判断表单值并提交
		checkSubmit: function(){
			const val = this.enterpriseDatas;
			const img = this.updateImgEnterprise;
			if ( val.names == '' || val.names == undefined ) {
				this.subTips = '*请输入法人姓名';
				return;
			} else if ( val.cardId == '' || val.cardId == undefined ) {
				this.subTips = '*请输入法人身份证号';
				return;
			}else if ( val.titles == '' || val.titles == undefined ) {
				this.subTips = '*请输入机构名称';
				return;
			}else if ( val.summary == '' || val.summary == undefined ) {
				this.subTips = '*请输入机构简介';
				return;
			}else if ( val.slogan == '' || val.slogan == undefined ) {
				this.subTips = '*请输入机构标语';
				return;
			}else if ( val.phone == '' || val.phone == undefined ) {
				this.subTips = '*请输入联系电话';
				return;
			}else if ( val.codes == '' || val.codes == undefined ) {
				this.subTips = '*请输入验证码';
				return;
			}else if ( img[0].url == '' || img[0].url == undefined ) {
				this.subTips = '*请上传法人身份证人像图';
				return;
			}else if ( img[1].url == '' || img[1].url == undefined ) {
				this.subTips = '*请上传法人身份证国徽图';
				return;
			}else if ( img[3].url == '' || img[3].url == undefined ) {
				this.subTips = '*请上传营业执照照片';
				return;
			}else if ( img[4].url == '' || img[4].url == undefined ) {
				this.subTips = '*请上传机构logo';
				return;
			} else {
				this.postEnterpriseName();
			}
			// else if ( img[2].url == '' || img[2].url == undefined ) {
			// 	this.subTips = '*请上传法人手持身份证图';
			// 	return;
			// }
		}
	}
}
</script>